import Toast, { ToastProps } from '@features/ui-atoms/components/Toast';
import { Id, toast, ToastOptions } from 'react-toastify';

export function showToast({ onClose, autoClose, ...props }: ToastProps & Pick<ToastOptions, 'autoClose'>): Id {
  return toast(({ closeToast }) => <Toast {...props} closeToast={closeToast} />, {
    position: 'bottom-right',
    closeButton: false,
    hideProgressBar: true,
    toastId: props.title,
    autoClose,
    // onClose is not triggered by the Toast component itself but here to catch all possible ways of closing the toast
    onClose,
    bodyStyle: {
      borderRadius: 0,
      margin: 0,
      padding: 0,
    },
    style: {
      backgroundColor: 'transparent',
      borderRadius: 0,
      minHeight: 0,
      padding: 0,
    },
  });
}
